import React from "react";
import { useTranslation } from "react-i18next";
import "./Contact.css";
import { GMAIL_TO, GMAIL_COMPOSE_URL } from "../../constants";

function Contact() {
  const { t } = useTranslation();

  return (
    <section className="py-5 py-lg-6 bg-white" id="contact">
      <div className="container">
        <div className="row justify-content-center mb-4 mb-lg-5">
          <div className="col-lg-8 text-center">
            <h2 className="h3 fw-semibold text-navy mb-2">{t('contact.heading')}</h2>
            <p className="text-muted mb-0">{t('contact.subheading')}</p>
          </div>
        </div>
        <div className="row g-4 g-lg-5">
          <div className="col-lg-5">
            <h3 className="h6 text-uppercase text-muted letter-spacing-wide mb-4">
              {t('contact.officeLabel')}
            </h3>
            <address className="text-navy mb-4 fst-normal">
              {t('contact.address')}
              <br />
              {t('contact.city')}
            </address>
            <dl className="mb-0 small">
              <dt className="text-muted fw-normal mb-1">{t('contact.phoneLabel')}</dt>
              <dd className="mb-3">
                <a
                  className="link-navy text-decoration-none"
                  href="tel:+9613313264"
                  dir="ltr"
                >
                  +961 3 313 264
                </a>
              </dd>
              <dt className="text-muted fw-normal mb-1">{t('contact.emailLabel')}</dt>
              <dd className="mb-3">
                <a
                  className="link-navy text-decoration-none"
                  href={GMAIL_COMPOSE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {GMAIL_TO}
                </a>
              </dd>
            </dl>
          </div>
          <div className="col-lg-7">
            <div className="rounded-3 overflow-hidden border border-secondary-subtle shadow-sm">
              <div className="ratio ratio-4x3">
                <iframe
                  title="Marwa Hawshar, Lawyer Office"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3290.7722879519283!2d35.8343484!3d34.43253879999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1521f700144ae4ed%3A0x5c2492adebf6ed3e!2z2YXZg9iq2Kgg2KfZhNmF2K3Yp9mF2YrYqSDZhdix2YjZhyDZh9mI2LTYsSDZhdit2KfZhSDYqNin2YTYpdiz2KrYptmG2KfZgQ!5e0!3m2!1sen!2slb!4v1776017597571!5m2!1sen!2slb"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
            <p className="small text-muted mt-3 mb-0">
              <a
                className="link-navy text-decoration-none"
                href="https://www.google.com/maps?q=Al%20Nejmeh%20Square%2C%20Tripoli%2C%20Lebanon"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('contact.openMaps')}
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
